<template>
  <div class="w-full h-full">
    <template v-if="loading">
      <slot name="loading">
        <div class="flex items-center justify-center h-screen">
          <div class="spinner"></div>
        </div>
      </slot>
    </template>
    <div v-if="loaded">
      <slot></slot>
    </div>
    <template v-if="errorLoading && !loading">
      <slot name="error">
        <div class="flex flex-col items-center justify-center h-screen">
          <div class="text-sm text-current">An error occurred while loading</div>
          <button type="button" class="text-sm underline text-primary" @click="retry">Retry</button>
        </div>
      </slot>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
    },
    loaded: {
      type: Boolean,
      default: false,
    },
    errorLoading: {
      type: Boolean,
    },
    retry: {
      type: Function,
      default: () => {
        this.$emit("retry");
      },
    },
  },
};
</script>